module.exports = __webpack_public_path__ + "img/jiuzhou-user-weixin.ea89f504.png";